/** 對外客戶站（產品履歷）連結。網址由 `VITE_CUSTOMER_PORTAL_URL` 設定；未設定時不顯示入口。 */

const SN_PLACEHOLDER = '{sn}';

/**
 * 依序號組客戶站連結。網址含 `{sn}` 時帶入序號，否則只連首頁。
 * @param {string} baseUrl
 * @param {unknown} serialNumber
 * @returns {string | null}
 */
export function buildCustomerPortalUrl(baseUrl, serialNumber) {
  const base = String(baseUrl ?? '').trim();
  if (!base) {
    return null;
  }
  if (!base.includes(SN_PLACEHOLDER)) {
    return base;
  }
  const sn = String(serialNumber ?? '').trim();
  if (!sn) {
    return null;
  }
  return base.split(SN_PLACEHOLDER).join(encodeURIComponent(sn));
}

/**
 * @param {unknown} serialNumber
 * @returns {string | null}
 */
export function getCustomerPortalSnUrl(serialNumber) {
  return buildCustomerPortalUrl(import.meta.env.VITE_CUSTOMER_PORTAL_URL, serialNumber);
}
